import {useState} from 'react'
import {languages} from 'monaco-editor/esm/vs/editor/editor.api'
import {
  ExpressionEditor,
  ExpressionEditorAutoCompleteContext,
  ExpressionEditorAutoCompleteProviderArgs,
  IExpressionConfig,
  fieldStatsToAutoCompleteSuggestions,
  defaultAutoCompleteSuggestions,
} from '@/features/expressions'
import {IDataSourceStats} from '@/features/data-sources'

export interface IEventFiltersProps {
  predictionStats?: IDataSourceStats
  onRunExpression: (expression: IExpressionConfig) => void
}

export function EventFilters(props: IEventFiltersProps) {
  const language = 'prediction-expression-lang'

  const {predictionStats, onRunExpression} = props

  const [filterExpression, setFilterExpression] = useState<IExpressionConfig>()

  function generateExpressionAutoCompleteSuggestions(
    args: ExpressionEditorAutoCompleteProviderArgs
  ): languages.CompletionItem[] {
    return [
      ...defaultAutoCompleteSuggestions(args),
      ...(predictionStats ?
        fieldStatsToAutoCompleteSuggestions({
          ...args,
          fieldTypes: predictionStats.fieldTypes,
        })
      : []),
    ]
  }

  return (
    <div>
      <ExpressionEditorAutoCompleteContext
        language={language}
        suggestions={generateExpressionAutoCompleteSuggestions}
      >
        <ExpressionEditor
          showParams
          isEditableAsJson
          fitToContent
          language={language}
          value={filterExpression}
          onChange={(expression: IExpressionConfig) => setFilterExpression(expression)}
          onRunExpression={onRunExpression}
          options={{
            lineNumbers: 'off',
          }}
        />
      </ExpressionEditorAutoCompleteContext>
    </div>
  )
}
